import { useEffect } from 'react'

export const useKeyboardShortcut = (key, callback, enabled = true, shouldPreventDefault = true, condition = () => true) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === key && condition() && enabled) {
        if (shouldPreventDefault) {
          event.preventDefault()
        }
        callback()
      }
    }

    if (enabled) {
      document.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [key, callback, enabled, shouldPreventDefault, condition])
}
